<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <!-- <el-button
            plain
            class="add-column-btn bbox"
            @click="addFlag('')"
            type="primary"
          >
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button
          > -->
                      <el-tooltip content="新增" >
              <el-button 
          style="height: 40px" @click="gotoDetail('')" type="primary"
            ><i class="el-icon-plus fw900 f16" style="font-size: 18px"></i
          ></el-button>
  </el-tooltip>

            <el-tooltip content="批量删除" >
              <el-button
            style="height: 40px; background-color: #ffb800; color: #fff"
            @click="groupDel"
          >
            <i class="el-icon-delete fw900 f16" style="font-size: 18px"></i
          ></el-button>
  </el-tooltip>
        </el-col>
        <el-col>
          <div class="flex align-center justify-end header-search-box">
            <el-input
              placeholder="查询条件"
              clearable
              v-model="searchInput"
              class="header-search-input ml10"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="textblue searchBtn"
                @click="search()"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <!-- <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="商户编码" align="center"  prop="商户编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column label="商户名称" align="center" prop="商户名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.merchantName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="子商户号"
                align="center"
                prop="子商户，（嘉联商户号）"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.subMchId }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="微信支付appId"
                align="center"
                prop="微信支付appId（嘉联机构号）"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.appId }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="微信支付appSecret"
                align="center"
                prop="微信支付appSecret"
              >
                <template slot-scope="scope">
                  <el-popover placement="bottom" width="400" trigger="hover">
                    <span>{{ scope.row.appSecret }}</span>
                    <span slot="reference">{{
                      scope.row.appSecret.substr(1, 20) + "..."
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <!-- <el-table-column label="令牌" align="center"  prop="令牌" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.token }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="消息加解密密钥" align="center"  prop="消息加解密密钥" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.encodingAESKey }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="微信支付pId" align="center"  prop="微信支付pId" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.pId }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="微信支付pkey" align="center"  prop="微信支付pkey" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.pkey }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="微信公众号的原始ID" align="center"  prop="微信公众号的原始ID" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.originalID }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付宝pid" align="center"  prop="支付宝pid" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.alipayPid }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付宝appid" align="center"  prop="支付宝appid" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.alipayAppid }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付宝公钥" align="center"  prop="支付宝公钥" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.alipayPublicKey }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付宝应用公钥" align="center"  prop="支付宝应用公钥" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.alipayAppPublicKey }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付宝应用私钥" align="center"  prop="支付宝应用私钥" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.alipayAppPrivateKey }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="在线点餐URL" align="center"  prop="在线点餐URL" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderOnlineUrl }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="个人中心URL" align="center"  prop="个人中心URL" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.memberCenterUrl }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="微信掉接口的AccessToken" align="center"  prop="微信掉接口的AccessToken" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.accessToken }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="AccessToken创建时间" align="center"  prop="AccessToken创建时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tokenCreateTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="AccessToken有效时间" align="center"  prop="AccessToken有效时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tokenExpiresIn }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="用微信卡券JS" align="center"  prop="用微信卡券JS" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.apiTicket }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="用微信卡券JS" align="center"  prop="用微信卡券JS" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.apiTicketCreateTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="用微信卡券JS" align="center"  prop="用微信卡券JS" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.apiTicketExpiresIn }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="通用消息模板" align="center"  prop="通用消息模板" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.commonMsgTpltId }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="消费发送消息模板" align="center"  prop="消费发送消息模板" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.consumeMsgTpltId }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="优惠券发送消息模板" align="center"  prop="优惠券发送消息模板" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.couponMsgTpltId }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付宝商户授权token" align="center"  prop="支付宝商户授权token" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.alipayAppAuthToken }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="支付通道" align="center" prop="支付通道">
                <template slot-scope="scope">
                  <span>{{ scope.row.payChannel }}通道</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-edit textblue f16"
                      @click="gotoDetail(scope.row.id, scope.row.userCode)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-delete textblue f16 ml20"
                      @click="del(scope.row.id)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="码牌下载"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-download textblue f16 ml20"
                      @click="downloadPaymentCode(scope.row.id)"
                    ></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table> </el-row
        ></el-scrollbar>
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.id = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //判断是否可以添加账户
    addFlag(id) {
      var that = this;

      let merchantCode = localStorage.getItem("merchantCode");
      var code = "";
      that.$http
        .post("merchantAccountInfo/queryMerchantAccountInfoCount", {
          merchantCode
        })
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            code = response.data.data.code;
            console.log(code);
            if (code == "1") {
              gotoDetail(id);
            } else {
              that.$message("一个商户只能够添加一条支付账户");
            }
          }
        });
    },
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantAccountInfo/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantAccountInfo/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        "merchantCode"
      );
      that.$http
        .post("/merchantAccountInfo/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    //码牌下载
    downloadPaymentCode(id) {
      var that = this;
      let data = {};
      data.id = id;
      that.$http
        .post("/merchantAccountInfo/downloadPaymentCode", data)
        .then(response => {
          if (response.data.code == 200) {
            // var a = document.createElement("a");
            // a.href = response.data.data;
            // a.download = response.data.data;
            // a.style.display = "none";
            // document.body.appendChild(a);
            // a.click();
            // a.remove();
            // that.$message.success("下载成功");
            window.open(response.data.data, "_blank");
            // window.location.href(response.data.data);
          } else {
            that.$notify.error({
              title: "提示",
              message: response.data.message,
              showClose: true
            });
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
</style>
